// extracted by mini-css-extract-plugin
export default {"mainContainer":"ProductSubmission_mainContainer__7Dt6g","submissionContainer":"ProductSubmission_submissionContainer__Kt6Kz"};